import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from 'src/app/services/config.service';
import { AlertService } from 'src/app/pages/shared/alert/alert.service';
import { G2PromptDialogComponent } from 'src/app/pages/shared/g2-prompt-dialog/g2-prompt-dialog.component';
import { G2ReviewDialogComponent } from 'src/app/pages/shared/g2-review-dialog/g2-review-dialog.component';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Menu } from './interfaces';
export interface panelData {
  title: any;
  name: any;
  route: any;
  links: [];
}

@Component({
  selector: 'app-layout-shtiks',
  templateUrl: './layout-shtiks.component.html',
  styleUrls: ['./layout-shtiks.component.scss'],
  animations: [
    trigger('collapseExpand', [
      state(
        'collapsed',
        style({
          width: '60px', // Width when collapsed
        })
      ),
      state(
        'expanded',
        style({
          width: '20rem', // Width when expanded
        })
      ),
      transition('collapsed <=> expanded', animate('300ms ease-in-out')),
    ]),
  ],
})
export class LayoutShtiksComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  hideSideMenu = false;
  isCollapsed: boolean = false;
  public MenuData: any;
  masterData: any = [];
  data: any;
  menuStartingIndex = 0;
  isSidebarOpen: boolean = false;
  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  public MenuDataAccount = [
    {
      title: 'Client',
      name: '',
      route: '',
      image: '',
      links: [
        {
          label: 'Account Management',
          name: 'Account Management',
          route: '/account-management/company-account',
          image: '../../../assets/images/Vector (5).png',
          iconClass: 'icon-settings',
          links: [
            {
              name: 'Company Account',
              route: '/account-management/company-account',
              image: '',
              links: [],
            },
          ],
        },
      ],
    },
  ];

  currentEnv: { name: string, color: string, bgColor: string } | undefined;
  envs: { [key: string]: { name: string, color: string, bgColor: string } } = {
    testing: {
      name: 'testing',
      color: '#fff',
      bgColor: 'rgba(0, 123, 255, 0.8)'
    },
    staging: {
      name: 'staging',
      color: '#fff',
      bgColor: 'rgba(255, 165, 0, 0.8)'
    },
    sandbox: {
      name: 'sandbox',
      color: '#fff',
      bgColor: 'rgba(40, 167, 69, 0.8)'
    },
    demo: {
      name: 'demo',
      color: '#fff',
      bgColor: 'rgba(220, 53, 69, 0.8)'
    },
  }

  public MenuDataClient = [
    {
      title: 'Client',
      name: '',
      route: '',
      image: '',
      links: [
        {
          name: 'Dashboard',
          route: '/dashboard',
          image: '../../../assets/images/dashboard-ico.svg',
          iconClass: 'icon-dashboard',
          links: [],
        },
        {
          label: 'Inbound',
          name: 'Inbound',
          route: '/inbound/purchase-request',
          image: '../../../assets/images/inbound-ico.svg',
          iconClass: 'icon-inbound',
          links: [
            {
              name: 'Purchase Request',
              route: '/inbound/purchase-request',
              image: '',
              links: [],
            },
            {
              name: 'Inbound Orders',
              route: '/inbound/purchase-order',
              image: '',
              links: [],
            },
            {
              name: 'ASN',
              route: '/inbound/asn',
              image: '',
              links: [],
            },
          ],
        },
        // {
        //   label: 'Receiving',
        //   name: 'Receiving',
        //   route: '/receiving/unload',
        //   image: '../../../assets/images/Group (1).png',
        //   iconClass: 'icon-receiving',
        //   links: [
        //     {
        //       name: 'Unload',
        //       route: '/receiving/unload',
        //       image: '',
        //       links: [],
        //     },
        //     {
        //       name: 'Receive',
        //       route: '/receiving/receive',
        //       image: '',
        //       links: [],
        //     },
        //     {
        //       name: 'Direct Receiving',
        //       route: '/receiving/unload-receive',
        //       image: '',
        //       links: [],
        //     },
        //   ],
        // },
        {
          label: 'Inventory',
          name: 'Inventory',
          route: '/inventory/overview',
          image: '../../../assets/images/Vector (8).png',
          iconClass: 'icon-inventory',
          links: [
            {
              name: 'Overview',
              route: '/inventory/overview',
              image: '',
              links: [],
            },
            {
              name: 'Adjustments',
              route: '/inventory/inventory-adjustments',
              image: '',
              links: [],
            },
          ],
        },
        {
          label: 'Outbound',
          name: 'Outbound',
          route: '/outbound/sales-requests',
          image: '../../../assets/images/Vector (7).png',
          iconClass: 'icon-outbound',
          links: [
            {
              name: 'Sales Requests',
              route: '/outbound/sales-requests',
              image: '',
              links: [],
            },
            {
              name: 'Outbound Orders',
              route: '/outbound/sales-orders',
              image: '',
              links: [],
            },
            {
              name: 'Pending Queue',
              route: '/outbound/pending-queue',
              image: '',
              links: [],
            },
          ],
        },
        {
          label: 'Fulfillment',
          name: 'Fulfillment',
          route: '/fulfillment/fulfillment-requests',
          image: '../../../assets/images/Vector (7).png',
          iconClass: 'icon-fulfillment',
          links: [
            {
              name: 'Fulfillment Requests',
              route: '/fulfillment/fulfillment-requests',
              image: '',
              links: [],
            },

            // {
            //   name: 'Shipment Requests',
            //   route: '/fulfillment/shipment-requests',
            //   image: '',
            //   links: [
            //   ]
            // }
          ],
        },
        {
          label: 'Setup',
          name: 'Setup',
          route: '/setup/product-catalog',
          image: '../../../assets/images/Vector (5).png',
          iconClass: 'icon-settings',
          links: [
            {
              name: 'SKUs',
              route: '/setup/product-catalog',
              image: '',
              links: [],
            },
            {
              name: 'Customers',
              route: '/setup/customers',
              image: '',
              links: [],
            },
            {
              name: 'Vendors',
              route: '/setup/vendors',
              image: '',
              links: [],
            },
            {
              name: 'Users',
              route: '/setup/users',
              image: '',
              links: [],
            },
            {
              name: 'Roles',
              route: '/setup/roles',
              image: '',
              links: [],
            },
            {
              name: 'Lookups',
              route: '/setup/lookup',
              image: '',
              links: [],
            },
          ],
        },
      ],
    },
  ];

  public MenuDataServiceProvider: Menu;

  currentRoute: any;
  activeWarehouse = false;

  private g2Checked = false;

  constructor(
    public service: ConfigService,
    public router: Router,
    private route: Router,
    public alert: AlertService,
    public ngxLoader: NgxUiLoaderService,
    public route1: ActivatedRoute,
    private dialog: MatDialog,
  ) {
    this.getMenu();
    // this.getPermissions();

    //temporary solution for not adding irrevelant param in url
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((ev) => {

      if (ev instanceof NavigationEnd) {
        //console.log(ev.url, "url");
        this.reRenderMenuState(ev.url.split('/')[1]);


        if (ev.url == '/setup/areas/list' || ev.url == '/setup/location/list' || ev.url == '/setup/parent-area/list') {
          this.route.navigate(['/dashboard']);
        }

        if (
          ev.url.startsWith(`/setup/areas`) ||
          ev.url.startsWith(`/setup/location`) ||
          ev.url.startsWith(`/setup/parent-area`)
        ) {
          this.activeWarehouse = true;
        } else {
          this.activeWarehouse = false;
        }

        let param = ev.url.split('/')[2];
        if (this.service.accountTypeAPI == 'wms_service') {
          let authParam = this.service.spRoles[0].restrictedPages.find(
            (x: any) => x == param
          );
          if (authParam) {
            this.route.navigate(['/dashboard']);
            this.alert.show('Page not found', 'error');
          }
        } else if (this.service.accountTypeAPI == 'client_service') {
          let authParam = this.service.spRoles[1].restrictedPages.find(
            (x: any) => x == param
          );
          if (authParam) {
            this.route.navigate(['/dashboard']);
            this.alert.show('Page not found', 'error');
          }
        }

      }
    });

  }

  reRenderMenuState(active_module: string) {

    // Matched by route, not name — a name like 'Labor Dashboard' never equals its
    // own route segment ('labour'), so a name-based match left every leaf but
    // 'Dashboard' unable to ever highlight itself after navigating.
    this.MenuData[0].links?.forEach((subItems: any) => {
      const routeSegment = (subItems?.route ?? '')
        .toString()
        .replace(/^\//, '')
        .split('/')[0]
        .toLocaleLowerCase();

      subItems.isOpen = !!routeSegment && routeSegment === active_module?.toLocaleLowerCase();
    })

  }

  async getMenu() {
    this.ngxLoader.start()
    this.route1.data.subscribe(data => {
      if (data['menu'] && data['menu'].status && data['menu'].data) {
        this.masterData = data['menu'].data.menu;
        this.MenuDataServiceProvider = this.masterData;
        this.menuDataUpdate();
      }
      this.data = data['data']; // Access other resolved data here
    });
    this.ngxLoader.stop()
  }

  menuDataUpdate() {
    let FilteredMenuDataServiceProvider: any = [];
    if (this.service.profileDetail?.account_type === 'service_provider') {
      for (
        let index = 0;
        index < this.MenuDataServiceProvider[0].links.length;
        index++
      ) {
        this.MenuDataServiceProvider[0].links[index].links =
          this.MenuDataServiceProvider[0].links[index].links.filter(
            (value: any) => Object.keys(value).length !== 0
          );
      }
      for (
        let index = 0;
        index < this.MenuDataServiceProvider[0].links.length;
        index++
      ) {
        // This filter drops groups whose children were all permission-filtered away.
        // Top-level items that are a single page by design have no children at all,
        // so they must be named here or they vanish even when permitted — Dashboard
        // was the only one until Labor, then Shipment Tracking.
        if (
          this.MenuDataServiceProvider[0].links[index].name == 'Dashboard' ||
          this.MenuDataServiceProvider[0].links[index].name == 'Labor Dashboard' ||
          this.MenuDataServiceProvider[0].links[index].name == 'Shipment Tracking Dashboard' ||
          this.MenuDataServiceProvider[0].links[index].links.length > 0
        ) {
          FilteredMenuDataServiceProvider.push(
            this.MenuDataServiceProvider[0].links[index]
          );
        }
      }
      this.MenuDataServiceProvider[0].links = FilteredMenuDataServiceProvider;
      this.MenuData = this.MenuDataServiceProvider;
      // console.log('Menu data', this.MenuData);
    } else if (this.service.profileDetail?.account_type === 'client') {
      // this.MenuDataClient[0].links = this.MenuDataClient[0].links.filter(value => Object.keys(value).length !== 0);
      this.MenuData = this.MenuDataClient;
    } else if (this.service.profileDetail?.account_type === 'admin' || this.service.profileDetail?.account_type === 'company_account') {
      // this.MenuDataClient[0].links = this.MenuDataClient[0].links.filter(value => Object.keys(value).length !== 0);
      this.MenuData = this.MenuDataAccount;
    }
  }
  calculatePadding() {
    return this.isCollapsed ? '60px' : '20rem';
  }
  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    const match = window.location.href.match(/testing|staging|sandbox|demo/i);
    const environment = match ? match[0].toLowerCase() : 'production';
    console.log(environment);
    this.currentEnv = this.envs[environment];
    // console.log(this.isSidebarOpen, 'this.isSidebarOpen');
    // console.log('this.service.permissions', this.MenuDataClient);
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd && event.url) {
        this.currentRoute = event.url;
        this.openMenuForCurrentRoute();
        this.maybeShowG2Prompt();
      }
    });
    this.currentRoute = this.router.url;
    this.openMenuForCurrentRoute();
    this.openSubMenuForCurrentRoute()
    this.subMenuInitialHighlighter();
    // this.toggleAllMenus(this.MenuData[0].links);
  }

  // ---------- G2 in-app review auto-prompt ----------
  // Checked once per session: first NavigationEnd triggers the /should-prompt call.
  // If the user has completed 20+ tasks since the last prompt (and hasn't reviewed yet),
  // show a small confirmation dialog; Yes opens the G2 iframe, No snoozes for 20 more tasks.
  private async maybeShowG2Prompt(): Promise<void> {
    if (this.g2Checked) return;
    this.g2Checked = true;

    let res: any;
    try {
      res = await this.service.getApi(
        '/api/integrations/g2/should-prompt', {}, '', 'wms_service',
      );
    } catch {
      return;
    }
    if (!(res?.status === 200 && res?.success === true && res?.data?.prompt)) return;

    const promptRef = this.dialog.open(G2PromptDialogComponent, {
      width: '760px',
      maxWidth: '95vw',
      panelClass: 'g2-prompt-dialog',
      autoFocus: false,
      disableClose: true,
    });

    promptRef.afterClosed().subscribe(async (yes: boolean) => {
      if (yes) {
        setTimeout(() => this.openG2Review(), 300);
      } else {
        try {
          await this.service.postApi(
            '/api/integrations/g2/dismiss-prompt', {}, null, 'wms_service',
          );
        } catch { /* silent */ }
      }
    });
  }

  private async openG2Review(): Promise<void> {
    this.ngxLoader.start();
    const res: any = await this.service.postApi(
      '/api/integrations/g2/review-url', {}, {}, 'wms_service',
    );
    this.ngxLoader.stop();

    if (res?.status === 200 && res?.success === true && res?.data?.url) {
      this.dialog.open(G2ReviewDialogComponent, {
        width: '1100px',
        maxWidth: '95vw',
        height: '95vh',
        panelClass: 'g2-dialog',
        disableClose: true,
        data: { url: res.data.url },
      });
    } else {
      this.alert.show(res?.error?.message || 'Could not open G2 review form.', 'error');
    }
  }

  toggleAllMenus(links: any[]) {
    // console.log('items: ', links);
    if (!links?.length) return;

    links.forEach((subMenu: any) => {
      // console.log('subMenu.name', subMenu.name);
      // console.log('subMenu', subMenu);
      if (subMenu.links?.length) {
        subMenu.isOpen = true;
        // recusively opening all the child links
        this.toggleAllMenus(subMenu.links);
      }
    });
  }

  subMenuInitialHighlighter() {
    const currentRoute = this.currentRoute.substring(1, this.currentRoute.length)
    const sideMenus = this.MenuData[this.menuStartingIndex].links;
    const currentRouteSub = this.currentRoute.substring(0, this.currentRoute.lastIndexOf('/'));
    sideMenus.forEach((sideMenu: any) => {
      sideMenu.links.forEach((subItem: any) => {
        if (subItem.route == currentRouteSub || subItem.route == currentRoute) {
          subItem.isOpen = true;
          sideMenu.isOpen = true
        }
      })
    })
  }

  openSubMenuForCurrentRoute() {
    const sideMenus = this.MenuData[this.menuStartingIndex].links;
    sideMenus.forEach((sideMenu: any) => {
      sideMenu.links.forEach((subItem: any) => {
        subItem.links.forEach((subSubItem: any) => {
          // console.log(subSubItem.route);
          if (subSubItem.route == this.currentRoute) {
            // subSubItem.isOpen = true;
            // console.log(subItem);
            subItem.isOpen = true;
            // sideMenu.isOpen = true;
          }
        })
      });
    })
  }



  openMenuForCurrentRoute() {
    const openMenu = (menuItems: any[], url: string): boolean => {
      const strippedUrl = this.removeLastSegment(url);
      for (const item of menuItems) {
        if (item.route === url) {
          item.isOpen = true;
          return true;
        }
        if (strippedUrl.startsWith(item.route)) { // matching the current route
          item.isOpen = true;
          return true;
        }
        if (item.links && item.links.length > 0) {
          if (openMenu(item.links, url)) {
            item.isOpen = true;
            return true;
          }
        }
      }
      return false;
    };
    if (this.MenuData && this.MenuData[0] && this.MenuData[0].links) {
      openMenu(this.MenuData[0].links, this.currentRoute);
    }
  }
  removeLastSegment(url: string): string {
    const segments = url.split('/');
    segments.pop();
    return segments.join('/');
  }
  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('email');
    localStorage.removeItem('password');
    localStorage.removeItem('rememberMe');
    this.route.navigate(['login']);
  }
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    // console.log(this.isSidebarOpen, 'this.isSidebarOpen Toggle');
  }
  closeSidebar(): void {
    this.isSidebarOpen = false;
  }
  handleSidebarItemClick(): void {
    this.closeSidebar();
  }

  // async getPermissions() {
  //   const response: any = await this.service.getApi('/api/user/permissions', {}, {}, 'auth_service');
  //   if (response.data.permissions) {
  //     this.service.permissions = response.data.permissions.formatted_permissions;
  //     localStorage.setItem('permissions', JSON.stringify(response.data.permissions.formatted_permissions));
  //     this.service.setPermissions();
  //   }
  // }

  checkPermission(item: any) {
    // console.log(item);
    return true;
  }

  sptoggle(event: any) {
    this.menuStartingIndex = event;
  }

  onToggleBtnClick() {
    this.hideSideMenu = !this.hideSideMenu;
  }

  routeToFirstNestedItem(routeTo: any) {
    this.route.navigate([routeTo]);
  }

  routeToList(routeTo: any) {
    this.route.navigate([routeTo]);
  }
  openListAllStatus() {
    this.service.selectedIndexForGridTabs = 0;
  }

  toggleMenu(item: any, menus?: any) {
    // A leaf item is a page, so it navigates; a group toggles its submenu. Checking
    // for "no children" rather than naming each leaf means Labor, and anything like
    // it added later, routes correctly without another special case here.
    if (item.name === 'Dashboard' || !item.links?.length) {
      this.navigateTo(item.route);
      // Highlight whichever leaf was actually clicked, not a hardcoded 'Dashboard' —
      // that hardcode meant every other leaf (e.g. Labor Dashboard) navigated but
      // never showed itself as the active sidebar item.
      this.MenuData[0].links?.forEach((subItems: any) => {
        subItems.isOpen = subItems === item;
      })

    } else {
      item.isOpen = !item.isOpen; // Toggle the submenu
    }
  }

  navigateTo(route: any, menus?: any, subItem?: any) {

    if (subItem && subItem?.url) {
      const accessToken = localStorage.getItem('access_token');
      const reportingUrl = `${subItem?.url}${accessToken}`;
      // window.location.href = reportingUrl;
      window.open(reportingUrl, '_blank');
      return;
    }
    this.MenuData[0].links?.forEach((subItems: any) => {

      if (subItems.name === "Dashboard") {
        subItems.isOpen = false;
      }
      subItems.links.forEach((element: any) => {
        // console.log(element);
        if (element.links.length <= 0) {// if 2nd level menu item is a drop down (have nested links) it will not get closed.
          element.isOpen = false
        }
      })
    })
    if (subItem) {
      subItem.isOpen = true;
    }


    this.route.navigate([route]);
  }



  handleSubSubItemHighlight(menus: any, subItem?: any) {
    // this fn hanldes the third level menu items such that if we click on any sub menu the other (2nd level menus) will get closed except for its own 2nd level menu which will act as dropdown.
    this.MenuData[0].links?.forEach((subItems: any) => {
      if (subItems.name === "Dashboard") {
        subItems.isOpen = false;
      }
      subItems?.links.forEach((element: any) => {
        if (element.name !== subItem.name) {
          element.isOpen = false;
        }
      })
    })
  }

}
